export default "__VITE_ASSET__CWMTIqQn__"